import { PropTypes } from "react";
import GrComponentFactory from "../../gr_component_factory";
import Modal from "../../modal";
import FriendFollowActions from "../../../react_actions/user_relationships/friend_follow_actions";
import { getUnfriendModalId } from "../../../modules/modal_id_helper";

export default GrComponentFactory.createClass({
  displayName: "UnfriendConfirmationModal",

  propTypes: {
    displayUser: PropTypes.shape({
      firstName: React.PropTypes.string.isRequired,
      viewableName: React.PropTypes.string.isRequired,
      userId: React.PropTypes.number.isRequired,
    }).isRequired,

    fromDropdown: PropTypes.bool,
  },

  getDefaultProps() {
    return { fromDropdown: false };
  },

  handleConfirmUnfriend() {
    FriendFollowActions.unfriend(this.props.displayUser.userId);
  },

  render() {
    return(
      <Modal id={getUnfriendModalId(this.props.displayUser.userId, this.props.fromDropdown)}
             bemModifiers="friendFollowModule"
             onConfirmHandler={this.handleConfirmUnfriend}>
        <div className="friendFollowConfirmModal">
          <h2 className="gr-h2 gr-h2--serif">Unfriend {this.props.displayUser.viewableName}?</h2>
          <div className="friendFollowConfirmModal__body">
            This will remove {this.props.displayUser.firstName}'s activity from your updates
            feed, and your own activity will stop appearing in their updates
            feed. {this.props.displayUser.firstName} will not be notified.
          </div>
        </div>
      </Modal>
    );
  },
});
